<div class="wrapper">
  <div class="d-flex flex-row align-items-center w-100 dialog-title">
    <div class="d-flex justify-content-center w-100">
      <h2 class="my-3" mat-dialog-title>Recover Password</h2>
    </div>
    <mat-icon [mat-dialog-close]="true" class="material-symbols-outlined close">close</mat-icon>
  </div>
  @if (!successMessage) {
    <form [formGroup]="emailForm" class="pb-3">
      <div class="d-flex flex-column justify-content-center align-items-center px-2 px-sm-5">
        <mat-form-field class="mt-4">
          <input type="email" placeholder="Email Address" aria-label="Email" matInput formControlName="email" required>
        </mat-form-field>
        <button class="accent small-btn" (click)="recoverPassword()">
          @if (!(spinner$ | async)?.show) {
            Recover Password
          }
          @if ((spinner$ | async)?.show) {
            <div class="d-flex justify-content-center w-100">
              <span class="spinner">
                <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="small" color="#fff" type="ball-spin-clockwise"
                [fullScreen]="false"></ngx-spinner>
              </span>
            </div>
          }
        </button>
        <mat-error class="text-center mt-3 mb-2">{{errorMessage}}</mat-error>
      </div>
    </form>
  } @else {
    <div class="d-flex justify-content-center p-3 my-5 text-center">
      <span>{{successMessage}}</span>
    </div>
  }
</div>